import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

const initialState = {
  authorPageData: { },
  authorBanner: null
}

const NAME = 'authorPage';
export const authorPageSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    changeAuthorPageData: (state, action) => {
      state.authorPageData = action.payload
    },
    changeAuthorBanner: (state, action) => {
      state.authorBanner = action.payload
    }
  },
  
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload[NAME]
      }
    })
  }
})

export const { changeAuthorPageData, changeAuthorBanner } = authorPageSlice.actions;
export default authorPageSlice;
